export default __webpack_public_path__ + "locales/sk/InfoPanel.json?hash=13f423b4b6623b868c9688604d95361c";